import React from "react";
import { Hero, Section, Steps } from "../components/Page/Page.js";
import LeadForm from "../components/Page/LeadForm.js";

export default function SellerListScreen() {
  return (
    <>
      <Hero eyebrow="Sellers / List your project" title="List your project with us" text="Tell us about your project and credits. We review every submission and reply within a few working days." />
      <Section title="What happens next" n="01">
        <Steps items={[
          ["Submit", "Share the basics below."],
          ["Review", "We check documents and certification."],
          ["Match", "We introduce you to suitable buyers."],
        ]} />
      </Section>
      <Section title="Project details" n="02" alt>
        <LeadForm
          kind="seller-listing"
          button="Submit project"
          fields={[
            ["company", "Organisation"],
            ["name", "Contact name"],
            ["email", "Email", "email"],
            ["project", "Project name"],
            ["type", "Project type", "select:Cookstoves,Solar,Energy efficiency,Waste to energy,Forestry or nature-based,Other"],
            ["registry", "Registry and ID (if any)", "text", false],
            ["stage", "Stage", "select:Idea,In design,Validated,Registered,Issuing credits"],
            ["location", "Country and region"],
            ["volume", "Expected credits per year (tCO2e)", "text", false],
            ["message", "Anything else we should know?", "textarea", false],
          ]}
        />
      </Section>
    </>
  );
}
